export default __webpack_public_path__ + "static/media/mail_logo.6be2bab7.svg";